// ProductRow — 상품 한 줄(보기 / 이름·카테고리 수정 / 삭제 확인 / 유효기간 수정).
//   MyProductManagement.jsx 의 renderRow + categoryEditor 를 그대로 옮겼다(동작 변화 없음).
import React from 'react';
import { SquarePen, Trash2 } from 'lucide-react';
import { input, btn, iconBtn, iconBtnIcon, deleteBtnIcon, rowStyle } from './productStyles';

// 카테고리 편집 컨트롤: 테넌트 = 자유 입력(자동완성), 운영자 = 전역 선택(미등록 값은 보존 옵션 추가)
function CategoryEditor({ freeCategory, categories, value, onChange }) {
  if (freeCategory) {
    return (
      <input style={{ ...input, width: 150 }} list="my-cat-options" placeholder="카테고리 (비우면 미분류)"
        value={value} onChange={(e) => onChange(e.target.value)} />
    );
  }
  const known = categories.some((c) => c.name === value);
  return (
    <select style={input} value={value} onChange={(e) => onChange(e.target.value)}>
      {!known && <option value={value}>{value ? `${value} (미등록)` : '미분류'}</option>}
      {categories.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
    </select>
  );
}

export function ProductRow({ p, fallbackCat, ctl }) {
  const {
    saving, freeCategory, categories,
    editId, setEditId, editName, setEditName, editCategory, setEditCategory,
    confirmId, setConfirmId,
    saveEdit, remove,
  } = ctl;

  return (
    <div style={rowStyle}>
      {editId === p.id ? (
        <>
          <input autoFocus style={{ ...input, flex: 1, minWidth: 140 }} value={editName}
            onChange={(e) => setEditName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') saveEdit(p.id); if (e.key === 'Escape') setEditId(null); }} />
          <CategoryEditor freeCategory={freeCategory} categories={categories} value={editCategory} onChange={setEditCategory} />
          <button style={btn} onClick={() => saveEdit(p.id)} disabled={saving}>저장</button>
          <button style={iconBtn} onClick={() => setEditId(null)}>취소</button>
        </>
      ) : confirmId === p.id ? (
        <>
          <span style={{ flex: 1, fontSize: 13, color: '#dc2626' }}>"{p.name}" 삭제(비활성화)?</span>
          <button style={{ ...btn, background: '#dc2626' }} onClick={() => remove(p.id)} disabled={saving}>확인</button>
          <button style={iconBtn} onClick={() => setConfirmId(null)}>취소</button>
        </>
      ) : (
        <>
          <span style={{ flex: 1, fontSize: 12, fontWeight: 400 }}>{p.name}</span>
          {p.company_code && <span style={{ fontSize: 10, fontWeight: 500, color: 'var(--text-muted)', border: '1px solid var(--border)', borderRadius: 4, padding: '1px 5px' }} title="소속 회사">{p.company_code}</span>}
          {/* 유효기간은 ⚙️ 설정으로 옮겼다 (2026-09-20) — 밖에는 매일 쓰는 이름·분류만 남긴다. */}
          {/* 수정: 네모+펜 아이콘 (2026-09-16 사용자 요청 — 이모지 연필은 누워 있어 알아보기 어려웠다) */}
          <button style={iconBtnIcon} title="이름·카테고리 수정" aria-label="이름·카테고리 수정"
            onClick={() => { setEditId(p.id); setEditName(p.name); setEditCategory(p.category || fallbackCat || ''); setConfirmId(null); }}>
            <SquarePen size={14} />
          </button>
          {/* 삭제: 휴지통 아이콘 (2026-09-16 사용자 요청 — ✕ 는 '수정 취소'와 헷갈렸다) */}
          <button style={deleteBtnIcon} title="삭제" aria-label="삭제"
            onClick={() => { setConfirmId(p.id); setEditId(null); }}>
            <Trash2 size={14} />
          </button>
        </>
      )}
    </div>
  );
}
